<template>
    <div class="attachments">
        <attachment
            v-for="(attachment, index) in filteredAttachments"
            :key="attachment.id"
            :attachment="attachment"
            @deleted="attachmentDeleted(index)"
            :view-only="viewOnly"
        />
        <span v-if="loading">Loading attachments, please wait...</span>
        <label
            class="attachments-btn btn btn-primary"
            v-if="!uploading"
            v-show="!viewOnly"
        > Choose file <input
            type="file"
            accept="image/*,.pdf"
            @change="fileChanged"
            multiple
        ></label>
        <button
            class="attachments-btn btn btn-primary"
            disabled
            v-if="uploading"
            v-show="!viewOnly"
        >
            Uploading, please wait...
        </button>
    </div>
</template>

<script>
import Service from '../services/AttachmentsService';
import UploadService from '../services/UploadService';
import Attachment from './AttachmentComponent';
import {uniq} from "lodash";

export default {
    components: {
        Attachment,
    },
    props: {
        type: {
            type: String,
            required: false,
            default: null,
        },
        id: {
            type: [String, Number],
            required: false,
            default: null,
        },
        viewOnly: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            loading: false,
            uploading: false,
            error: null,
            attachments: [],
        };
    },
    computed: {
        filteredAttachments: function () {
            return uniq(this.attachments, (a) => a.id);
        }
    },
    watch: {
        id () {
            this.loadAttachments();
        },
        type () {
            this.loadAttachments();
        },
    },
    mounted () {
        this.loadAttachments();
        this.listenForEvents();
    },
    beforeDestroy() {
        this.stopListeningToEvents();
    },
    methods: {
        loadAttachments () {
            if (!this.id || !this.type) {
                this.attachments = [];
                this.loading = false;
                return;
            }
            this.loading = true;
            Service.get(this.type, this.id).then(res => {
                this.attachments = res.data;
            }).then(() => {
                this.loading = false;
            })
        },
        fileChanged ($event) {
            this.uploading = true;
            this.error = null;
            for (let i = 0; i < $event.target.files.length; i++) {
                const file = $event.target.files[i];
                UploadService.upload(file, 1920).then(res => {
                    this.attachFile(res.data);
                }).catch(() => {
                    this.error = 'Failed to upload file';
                    window.alert('Error: ' + this.error);
                }).then(() => {
                    this.uploading = false;
                })
            }
        },
        attachFile(file) {
            if (!this.type || !this.id) {
                this.attachments.push({upload: file});
                this.emitAttachments();
                return;
            }
            const data = {
                upload_id: file.id,
                attachable_type: this.type,
                attachable_id: this.id,
            };
            Service.store(data).then(res => {
                this.emitAttachments();
            });
        },
        attachmentDeleted (index) {
            this.attachments.splice(index, 1);
            this.emitAttachments();
        },
        emitAttachments() {
            this.$emit('input', this.attachments);
        },
        listenForEvents() {
            window.Echo.private('attachments').listen('AttachmentChanged', e => {
                if (e.attachment.attachable_type === this.type && e.attachment.attachable_id == this.id) {
                    this.loadAttachments();
                }
            });
        },
        stopListeningToEvents() {
            window.Echo.leave('attachments');
        },
        clear () {
            this.attachments = [];
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/AttachmentsComponent.vue